import { DeviceCategory } from "../Core/DeviceCategory";
import { Device } from "../Core/Device";
import { HashSet } from "../Utils/HashSet";
import { List } from "../Utils/List";

export class DeviceAssociations {
	public static AssociatedDevices(device: Device, category: DeviceCategory): HashSet<Device> {
		var result = new HashSet<Device>();

		if (category == DeviceCategory.IpPhone || category == null)
			result.UnionWith(DeviceAssociations.AssociatedIpPhones(device));
		if (category == DeviceCategory.WirelessAp || category == null)
			result.UnionWith(DeviceAssociations.AssociatedWirelessAPs(device));
		if (category == DeviceCategory.WirelessController || category == null)
			result.UnionWith(DeviceAssociations.AssociatedWirelessControllers(device));
		if (category == DeviceCategory.VirtualServer || category == null)
			result.UnionWith(DeviceAssociations.AssociatedVirtualServers(device));
		if (category == DeviceCategory.Virtual || category == null)
			result.UnionWith(DeviceAssociations.AssociatedVirtualMachines(device));
		if (category == DeviceCategory.VirtualHost || category == null)
			result.UnionWith(DeviceAssociations.AssociatedVirtualHosts(device));

		return result;
	}

	private static AssociatedWirelessAPs(device: Device): HashSet<Device> {
		var result = new HashSet<Device>();

		if (device.HasApTable) {
			device.ApTable.ForEach((apEntry) => {
				var apDevices: List<Device> = device.Network.Devices.FindByMacAddress(apEntry.MacAddress);
				if ((apDevices == null) || (apDevices.Count <= 0)) {
					apDevices = device.Network.Devices.FindByMacAddress(apEntry.EthernetMacAddress);
					if ((apDevices == null) || (apDevices.Count <= 0))
						return;
				}

				result.Add(apDevices.Get(0));
			});
		}

		return result;
	}

	private static AssociatedWirelessControllers(device: Device): HashSet<Device> {
		var result = new HashSet<Device>();

		if (device.IsWirelessAP) {
			device.Network.Devices.FindByCategory(DeviceCategory.WirelessController).ForEach((controller) => {
				var aps: HashSet<Device> = this.AssociatedWirelessAPs(controller);
				if (aps.Contains(device))
					result.Add(controller);
			});
		}

		return result;
	}

	private static AssociatedIpPhones(device: Device): HashSet<Device> {
		var result = new HashSet<Device>();

		if (device.HasIpPhoneTable) {
			device.IpPhoneTable.ForEach((entry) => {
				if (!entry.HasMacAddress)
					return;

				var devices: List<Device> = device.Network.Devices.FindByMacAddress(entry.MacAddress);
				if (devices != null && devices.Count > 0)
					result.Add(devices.Get(0));
			});
		}

		return result;
	}

	private static AssociatedVirtualServers(device: Device): HashSet<Device> {
		var result = new HashSet<Device>();

		if (device.HasVirtualHostTable) {
			device.VirtualHostTable.ForEach((vhInfo) => {
				vhInfo.PhysicalNics.ForEach((entry) => {
					if (!entry.HasMacAddress)
						return;

					var devices: List<Device> = device.Network.Devices.FindByMacAddress(entry.MacAddress);
					if (devices != null && devices.Count > 0)
						result.Add(devices.Get(0));
				});

				vhInfo.VirtualNics.ForEach((entry) => {
					if (!entry.HasMacAddress)
						return;

					var devices: List<Device> = device.Network.Devices.FindByMacAddress(entry.MacAddress);
					if (devices != null && devices.Count > 0)
						result.Add(devices.Get(0));
				});
			});
		}

		if (device.HasVirtualMachineInfo) {
			device.Network.Devices.FindByCategory(DeviceCategory.VirtualServer).ForEach((vServer) => {
				var vms: HashSet<Device> = this.AssociatedVirtualMachines(vServer);
				if (vms.Contains(device))
					result.Add(vServer);
			});
		}

		return result;
	}

	private static AssociatedVirtualMachines(device: Device): HashSet<Device> {
		var result = new HashSet<Device>();

		if (device.HasVirtualMachineTable) {
			device.VirtualMachineTable.ForEach((vmInfo) => {
				result.Add(vmInfo.Device);
			});
		}

		return result;
	}

	private static AssociatedVirtualHosts(device: Device): HashSet<Device> {
		var result = new HashSet<Device>();

		if (device.HasVirtualHostInfo) {
			device.Network.Devices.FindByCategory(DeviceCategory.VirtualHost).ForEach((vHost) => {
				var vServers: HashSet<Device> = this.AssociatedVirtualServers(vHost);
				if (vServers.Contains(device))
					result.Add(vHost);
			});
		}

		return result;
	}
}
